/* ---------------------------------------------------------------------------
   VAT relief declaration, on the basket page.

   Checkout UI extensions are Plus-only, so the declaration is taken here and
   written to cart attributes via /cart/update.js. Attributes ride along to the
   order, so the signed declaration is on the order record in admin.

   Checkout stays blocked until it saves: selling zero-rated goods without a
   declaration is the thing this exists to prevent.
--------------------------------------------------------------------------- */
(function () {
  var root = document.querySelector('[data-vat-declaration]');
  if (!root) return;

  var status = root.querySelector('[data-vd-status]');
  var saveBtn = root.querySelector('[data-vd-save]');
  var condition = root.querySelector('[data-vd="Condition declared"]');
  var otherWrap = root.querySelector('[data-vd-other]');
  var otherInput = root.querySelector('[data-vd="Condition detail"]');
  var typedWrap = root.querySelector('[data-vd-typed]');
  var typedInput = document.getElementById('vatdec-typed');
  var drawnWrap = root.querySelector('[data-vd-drawn]');
  var canvas = root.querySelector('[data-vd-canvas]');
  var clearBtn = root.querySelector('[data-vd-clear]');
  var dateInput = root.querySelector('[data-vd="Declaration date"]');

  // every route to payment, so none of them skips the declaration
  var checkoutEls = Array.prototype.slice.call(
    document.querySelectorAll('[name="checkout"], .cartpage__checkout, .cart-drawer__checkout')
  );

  // The basket's own checkout button stays focusable while locked: a natively
  // disabled button cannot be tabbed to and ignores taps, so it could never say
  // why it was locked. The gate is enforced by the click and submit handlers.
  var pageCheckout = document.querySelector('.cartpage__checkout');
  var lockNote = document.querySelector('[data-vd-locknote]');

  /* ---------------------------------------------------------------- gating */

  var saved = false;

  function lockCheckout(reason) {
    checkoutEls.forEach(function (el) {
      if (el === pageCheckout) {
        el.disabled = false;
        el.setAttribute('aria-disabled', 'true');
        if (lockNote) el.setAttribute('aria-describedby', 'vat-lock-note');
      } else if (el.tagName === 'BUTTON') {
        el.disabled = true;
      } else {
        el.setAttribute('aria-disabled', 'true');
        el.dataset.vdHref = el.dataset.vdHref || el.getAttribute('href') || '';
        el.removeAttribute('href');
      }
      el.title = reason;
    });
    if (lockNote) lockNote.hidden = false;
  }

  function unlockCheckout() {
    checkoutEls.forEach(function (el) {
      if (el === pageCheckout) {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('aria-describedby');
      } else if (el.tagName === 'BUTTON') {
        el.disabled = false;
      } else {
        el.removeAttribute('aria-disabled');
        if (el.dataset.vdHref) el.setAttribute('href', el.dataset.vdHref);
      }
      el.removeAttribute('title');
    });
    if (lockNote) lockNote.hidden = true;
  }

  // A tap, Enter or Space on the locked button, or the note's link, takes the
  // visitor to what still needs doing instead of doing nothing.
  function goToForm() {
    var problem = firstProblem();
    var target = problem ? problem.el : saveBtn;
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (typeof target.focus === 'function') target.focus({ preventScroll: true });
    say(problem ? problem.message : 'Please save your declaration before going to checkout.', 'warn');
  }

  if (pageCheckout) {
    pageCheckout.addEventListener('click', function (e) {
      if (saved) return;
      e.preventDefault();
      goToForm();
    });
    if (pageCheckout.form) {
      pageCheckout.form.addEventListener('submit', function (e) {
        if (saved || !e.submitter || e.submitter.name !== 'checkout') return;
        e.preventDefault();
        goToForm();
      });
    }
  }
  // "Not VAT exempt?" swaps every zero-rated line for the same product's
  // standard variant at the same quantity, then reloads the basket. The
  // standard lines are added before the zero-rated ones are removed, so a
  // failure part way never empties the basket. cart-drawer.js clears the
  // declaration on the reload once no zero-rated line is left.
  var switchBtn = root.querySelector('[data-vd-switch]');
  if (switchBtn) {
    switchBtn.addEventListener('click', function () {
      var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var lines = switchBtn.dataset.vdSwitch.split(',').filter(Boolean).map(function (l) {
        var p = l.split('|');
        return { key: p[0], id: parseInt(p[1], 10), qty: parseInt(p[2], 10) };
      });
      var removals = {};
      lines.forEach(function (l) { removals[l.key] = 0; });
      function post(path, body) {
        return fetch(base + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then(function (r) {
          if (!r.ok) throw new Error(path + ' ' + r.status);
          return r.json();
        });
      }
      switchBtn.disabled = true;
      say('Switching to the price inc VAT…');
      post('cart/add.js', { items: lines.map(function (l) { return { id: l.id, quantity: l.qty }; }) })
        .then(function () { return post('cart/update.js', { updates: removals }); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          switchBtn.disabled = false;
          say('Sorry, that did not work. Please try again, or ring us on the number below.', 'error');
        });
    });
  }

  if (lockNote) {
    var noteLink = lockNote.querySelector('a');
    if (noteLink) noteLink.addEventListener('click', function (e) {
      e.preventDefault();
      goToForm();
    });
  }

  // already declared on this cart (the page reloads on quantity changes)
  if (root.hasAttribute('data-vd-declared')) {
    saved = true;
    say('Declaration saved. You can go to checkout.', 'ok');
  } else {
    lockCheckout('Please complete the VAT exemption declaration first');
  }

  /* ------------------------------------------------------- conditional bits */

  function syncCondition() {
    var isOther = condition.value === 'Other';
    otherWrap.hidden = !isOther;
    if (!isOther) otherInput.value = '';
  }
  condition.addEventListener('change', syncCondition);
  syncCondition();

  function method() {
    var picked = root.querySelector('[data-vd-method]:checked');
    return picked ? picked.value : 'type';
  }

  function syncMethod() {
    var drawing = method() === 'draw';
    typedWrap.hidden = drawing;
    drawnWrap.hidden = !drawing;
    if (drawing) fitCanvas();
  }
  root.querySelectorAll('[data-vd-method]').forEach(function (r) {
    r.addEventListener('change', function () {
      syncMethod();
      invalidate();
    });
  });
  syncMethod();

  // default to today, in the customer's own timezone
  if (dateInput && !dateInput.value) {
    var now = new Date();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    dateInput.value = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
  }

  /* -------------------------------------------------------- signature pad */

  var ctx = canvas ? canvas.getContext('2d') : null;
  var drawn = false;
  var drawing = false;

  function fitCanvas() {
    if (!ctx || !canvas.offsetWidth) return;
    // redraw-safe only while empty; resizing a signed pad would distort it
    if (drawn) return;
    var ratio = window.devicePixelRatio || 1;
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#1B1A17';
  }

  function pos(e) {
    var r = canvas.getBoundingClientRect();
    var p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - r.left, y: p.clientY - r.top };
  }

  function start(e) {
    e.preventDefault();
    drawing = true;
    var p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  }

  function move(e) {
    if (!drawing) return;
    e.preventDefault();
    var p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    drawn = true;
    invalidate();
  }

  function stop() { drawing = false; }

  // restore a previously drawn signature so a basket edit does not lose it
  if (canvas && root.dataset.vdSavedImage) {
    var restored = new Image();
    restored.onload = function () {
      fitCanvas();
      ctx.drawImage(restored, 0, 0, canvas.offsetWidth, canvas.offsetHeight);
      drawn = true;
    };
    restored.src = root.dataset.vdSavedImage;
  }

  if (canvas) {
    ['mousedown', 'touchstart'].forEach(function (t) { canvas.addEventListener(t, start, { passive: false }); });
    ['mousemove', 'touchmove'].forEach(function (t) { canvas.addEventListener(t, move, { passive: false }); });
    ['mouseup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function (t) { canvas.addEventListener(t, stop); });
    window.addEventListener('resize', fitCanvas);
    fitCanvas();
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawn = false;
      fitCanvas();
      invalidate();
    });
  }

  /* ------------------------------------------------------------ validation */

  function required() {
    var list = [
      root.querySelector('[data-vd="Disabled person name"]'),
      root.querySelector('[data-vd="Disabled person address"]'),
      condition,
      root.querySelector('[data-vd="Declaration signed by"]'),
      dateInput,
    ];
    if (condition.value === 'Other') list.push(otherInput);
    if (method() === 'type') list.push(typedInput);
    return list;
  }

  function firstProblem() {
    var missing = required().find(function (el) { return !el.value.trim(); });
    if (missing) return { el: missing, message: 'Please fill in every required field.' };
    if (method() === 'draw' && !drawn) {
      return { el: canvas, message: 'Please sign in the box, or choose "Type my name".' };
    }
    return null;
  }

  function invalidate() {
    if (!saved) return;
    saved = false;
    lockCheckout('Please save your VAT exemption declaration again');
    say('Your declaration has changed. Save it again before checking out.', 'warn');
  }

  root.addEventListener('input', invalidate);

  function say(message, kind) {
    status.textContent = message;
    status.className = 'vatdec__status' + (kind ? ' is-' + kind : '');
  }

  /* ---------------------------------------------------------------- saving */

  function signatureImage() {
    if (method() !== 'draw' || !drawn) return null;

    // The data URL travels as a cart attribute, so size matters. Scale down,
    // then flatten every pixel to opaque black or fully transparent: PNG
    // compresses flat areas far better than an anti-aliased grey edge, which
    // roughly halves the string for no loss of legibility.
    var out = document.createElement('canvas');
    out.width = 420;
    out.height = 130;
    var octx = out.getContext('2d');
    octx.drawImage(canvas, 0, 0, out.width, out.height);

    try {
      var img = octx.getImageData(0, 0, out.width, out.height);
      var d = img.data;
      for (var i = 0; i < d.length; i += 4) {
        var on = d[i + 3] > 90;
        d[i] = d[i + 1] = d[i + 2] = 0;
        d[i + 3] = on ? 255 : 0;
      }
      octx.putImageData(img, 0, 0);
    } catch (e) {
      // tainted canvas should be impossible here, but never lose the signature
      // over an optimisation
    }

    return out.toDataURL('image/png');
  }

  function collect() {
    var attrs = {};

    // Every field is sent on every save, including the empty ones. Omitting a
    // key leaves whatever was there before untouched, so changing the stated
    // condition away from "Other" used to leave the old condition detail
    // behind and the record could then contradict itself. An empty string
    // deletes the attribute.
    root.querySelectorAll('[data-vd]').forEach(function (el) {
      var key = el.dataset.vd;
      if (el.type === 'checkbox') {
        attrs[key] = el.checked ? 'Yes' : 'No';
      } else {
        attrs[key] = el.value.trim();
      }
    });

    attrs['VAT relief declared'] = 'Yes';
    attrs['Signature method'] = method() === 'draw' ? 'Drawn' : 'Typed';
    attrs['Signature'] = method() === 'draw'
      ? 'Drawn — see Signature image'
      : typedInput.value.trim();

    // Same reason: a typed signature must not leave a previously drawn image
    // sitting on the order.
    attrs['Signature image'] = method() === 'draw' ? signatureImage() || '' : '';

    return attrs;
  }

  saveBtn.addEventListener('click', function () {
    var problem = firstProblem();
    if (problem) {
      say(problem.message, 'error');
      problem.el.focus();
      return;
    }

    saveBtn.disabled = true;
    say('Saving…');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: collect() }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart rejected the declaration (' + r.status + ')');
        return r.json();
      })
      .then(function () {
        saved = true;
        unlockCheckout();
        say('Declaration saved. You can go to checkout.', 'ok');
      })
      .catch(function () {
        // most likely the drawn signature being too large for an attribute
        say(
          'Sorry, we could not save that. If you drew your signature, try ' +
            '"Type my name" instead, or ring us on the number below.',
          'error'
        );
      })
      .then(function () {
        saveBtn.disabled = false;
      });
  });
})();
